import * as React from 'react';
import cx from 'classnames';

import Link, { Props as LinkProps } from 'components/Link';
import TooltipTrigger from 'components/TooltipTrigger';

import './styles/MenuItem.scss';

export type Props = {
  href?: string;
  to?: string;
  onSelect?: (arg0: any) => any;
  onClick?: (arg0: React.MouseEvent) => any;
  // XXX this is whack typing
  // `selected` can take `true`, `false`, and `null`. When `true` or `false', the
  // item is considered "selectable" and will render a checkmark when checked.
  selected?: boolean | null;
  disabled?: boolean;
  tooltip?: React.ReactNode;
  noHover?: boolean;
  // Used by Menu
  menuKey?: any;
  eventScreenName?: string;
  eventElementName?: string;
  eventProperties?: object;
  eventKey?: string;
  className?: string;
} & Partial<LinkProps>;

class MenuItem extends React.Component<Props> {
  static defaultProps = {
    disabled: false,
    selected: null,
    noHover: false,
  };

  handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();

    if (this.props.disabled) {
      event.preventDefault();
    }

    if (this.props.disabled) {
      return;
    }

    if (this.props.selected) {
      return;
    }

    if (this.props.onSelect) {
      this.props.onSelect(this.props.menuKey);
    }

    if (this.props.onClick) {
      this.props.onClick(event);
    }
  };

  render() {
    const { className, tooltip, ...others } = this.props;
    const linkComponent = (
      <Link
        {...others}
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'false | "graphite"' is not assignable to typ... Remove this comment to see the full error message
        color={!this.props.selected && 'graphite'}
        className="MenuItem-link"
        eventScreenName={this.props.eventScreenName}
        eventElementName={this.props.eventElementName}
        eventProperties={this.props.eventProperties}
        onClick={this.handleClick}
      >
        {this.props.children}
      </Link>
    );

    return (
      <li
        className={cx(
          'MenuItem',
          {
            'MenuItem--selectable': typeof this.props.selected === 'boolean',
            'MenuItem--selected': !!this.props.selected,
            'MenuItem--disabled': this.props.disabled,
            'MenuItem--noHover': this.props.noHover,
          },
          className
        )}
      >
        {tooltip ? (
          <TooltipTrigger placement="left" alignment="top" tooltip={tooltip}>
            <span>{linkComponent}</span>
          </TooltipTrigger>
        ) : (
          linkComponent
        )}
      </li>
    );
  }
}

export default MenuItem;
